import { getIdToken } from '@/auth/authService';
import { config } from '@/config';

export class AdminApiError extends Error {
  constructor(public readonly kind: 'signed_out' | 'forbidden' | 'network' | 'server', message: string) { super(message); }
}

export async function adminGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  const token = await getIdToken();
  if (!token) throw new AdminApiError('signed_out', 'Authentication required');
  let response: Response;
  try {
    response = await fetch(`${config.apiUrl}${path}`, { headers: { Authorization: `Bearer ${token}` }, signal });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') throw error;
    throw new AdminApiError('network', 'Admin API is unreachable');
  }
  if (response.status === 401) throw new AdminApiError('signed_out', 'Session expired');
  if (response.status === 403) throw new AdminApiError('forbidden', 'Account is not authorized');
  if (!response.ok) throw new AdminApiError('server', `Admin API failed (${response.status})`);
  return response.json() as Promise<T>;
}
